export class CalendarModel {
  id: number = null;
  date: Date = null;
  description: string = null;
  typeName: string = null;
  typeDescription: string = null;
}

export class CalendarHolidaysRequestModel {
  year: number = null;
  types: string[] = [];
}

export class HolidayType {
  id: number = null;
  name: string = null;
  description: string = null;
}
